import React from "react";
import styled from "styled-components";
import { mobile, tablet } from "../responsive";
import { FormattedMessage } from "react-intl";

const PageContainer = styled.div`
    background: var(--wellness-light);
    padding: 0;
`;

const Section = styled.div`
    display: flex;
    align-items: center;
    padding: 8rem 6rem;
    gap: 4rem;
    max-width: 1400px;
    margin: 0 auto;
    flex-direction: ${props => props.reversed ? 'row-reverse' : 'row'};

    ${mobile({ 
        padding: "3rem 2rem",
        flexDirection: "column !important",
        gap: "2rem"
    })}
    ${tablet({ 
        padding: "4rem 3rem",
        flexDirection: "column !important",
        gap: "2rem"
    })}
`;

const Divider = styled.div`
    height: 1px;
    background: linear-gradient(
        to right,
        transparent,
        var(--wellness-neutral),
        transparent
    );
    max-width: 1400px;
    margin: 0 auto;
    width: calc(100% - 12rem);
    
    ${mobile({ width: "calc(100% - 4rem)" })}
    ${tablet({ width: "calc(100% - 6rem)" })}
`;

const ContentWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2rem;
`;

const SectionNumber = styled.span`
    font-size: 0.9rem;
    letter-spacing: 0.2em;
    color: var(--wellness-secondary);
    font-weight: 600;
    text-transform: uppercase;
    opacity: 0.7;
`;

const Title = styled.h1`
    font-family: Jost-Bold;
    font-size: 3rem;
    color: var(--wellness-primary);
    margin: 0;
    line-height: 1.2;
    
    ${mobile({ fontSize: "1.8rem" })}
    ${tablet({ fontSize: "2.2rem" })}
`;

const Desc = styled.p`
    font-size: 1.2rem;
    line-height: 1.8;
    color: var(--wellness-secondary);
    margin: 0;
    font-weight: 400;
    
    ${mobile({ fontSize: "1rem" })}
`;

const ImageGallery = styled.div`
    flex: 1;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 1rem;
    width: 100%;
    
    ${mobile({ 
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "0.8rem"
    })}
`;

const ImageCard = styled.div`
    position: relative;
    aspect-ratio: 1;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    overflow: hidden;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
    
    &:hover {
        transform: translateY(-8px);
        box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
    }
    
    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: url(${props => props.img});
        background-size: cover;
        background-position: center;
        opacity: ${props => props.img ? 1 : 0.3};
        transition: opacity 0.3s ease;
    }
    
    &:hover::before {
        opacity: 0.9;
    }
`;

const ImageLabel = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
    padding: 1.5rem 1rem 1rem;
    transform: translateY(100%);
    transition: transform 0.3s ease;
    
    ${ImageCard}:hover & {
        transform: translateY(0);
    }
    
    font-size: 0.9rem;
    color: white;
    text-align: center;
    font-weight: 600;
    ${mobile({ fontSize: "0.75rem", padding: "1rem 0.75rem 0.5rem" })}
`;



const setA = [
    {
        url: "https://ik.imagekit.io/dnddecpho/airvitamin/Screenshot_20241007_152016~3_w9NSCJw5i.jpg?updatedAt=1732898457323",
        title: <FormattedMessage id="bg_img_1" defaultMessage="" />,
    },
    {
        url: "https://ik.imagekit.io/dnddecpho/airvitamin/Screenshot_20241007_150936~3_50zwdzHfK.jpg?updatedAt=1732898453828",
        title: <FormattedMessage id="bg_img_2" defaultMessage="" />,
    },
    {
        url: "https://ik.imagekit.io/dnddecpho/airvitamin/Screenshot_20241007_151712~4_qkYKW9TqE.jpg?updatedAt=1732898456707",
        title: <FormattedMessage id="bg_img_3" defaultMessage="" />,
    },
];

const setB = [
    {
        url: "https://ik.imagekit.io/dnddecpho/airvitamin/Screenshot_20241007_153608~2_HLeVXyeF_.jpg?updatedAt=1732898456695",
        title: <FormattedMessage id="bg_img_4" defaultMessage="" />,
    },
    {
        url: "https://ik.imagekit.io/dnddecpho/airvitamin/Screenshot_20241007_153713~2_a0iT4QKwJ.jpg?updatedAt=1732898456687",
        title: <FormattedMessage id="bg_img_5" defaultMessage="" />,
    },
    {
        url: "https://ik.imagekit.io/dnddecpho/airvitamin/Screenshot_20241007_153431~2_yHcyhYzSg.jpg?updatedAt=1732898456701",
        title: <FormattedMessage id="bg_img_6" defaultMessage="" />,
    },
    {
        url: "https://ik.imagekit.io/dnddecpho/airvitamin/Screenshot_20241007_153830~2_y5eDceT1a.jpg?updatedAt=1732898457508",
        title: <FormattedMessage id="bg_img_7" defaultMessage="" />,
    },
];

const setC = [
    {
        url: "https://ik.imagekit.io/dnddecpho/airvitamin/Screenshot_20241007_171819~2_6XtRjj8IV.jpg?updatedAt=1732898453897",
        title: <FormattedMessage id="bg_img_8" defaultMessage="" />,
    },
    {
        url: "https://ik.imagekit.io/dnddecpho/airvitamin/Screenshot_20241007_171936~3_qsOEkoO9jD.jpg?updatedAt=1732898453939",
        title: <FormattedMessage id="bg_img_9" defaultMessage="" />,
    },
    {
        url: "https://ik.imagekit.io/dnddecpho/airvitamin/Screenshot_20241007_172008~3_Y9BPZJSIsh.jpg?updatedAt=1732898454000",
        title: <FormattedMessage id="bg_img_10" defaultMessage="" />,
    },
    {
        url: "https://ik.imagekit.io/dnddecpho/airvitamin/Screenshot_20241007_171853~3_HTV3SVuPIg.jpg?updatedAt=1732898453894",
        title: <FormattedMessage id="bg_img_11" defaultMessage="" />,
    },
    {
        url: "https://ik.imagekit.io/dnddecpho/airvitamin/Screenshot_20241007_171723~2_635OiVh1p.jpg?updatedAt=1732898457632",
        title: <FormattedMessage id="bg_img_12" defaultMessage="" />,
    },
];

const setD = [
    {
        url: "https://ik.imagekit.io/dnddecpho/airvitamin/Screenshot_20241007_172920~2_Yi00vRjS7.jpg?updatedAt=1732898453953",
        title: <FormattedMessage id="bg_img_13" defaultMessage="" />,
    },
    {
        url: "https://ik.imagekit.io/dnddecpho/airvitamin/Screenshot_20241007_172913~2_8024sP00Bi.jpg?updatedAt=1732898453824",
        title: <FormattedMessage id="bg_img_14" defaultMessage="" />,
    },
    {
        url: "https://ik.imagekit.io/dnddecpho/airvitamin/Screenshot_20241007_173131~2_-lBIHy9Xl.jpg?updatedAt=1732898453812",
        title: <FormattedMessage id="bg_img_15" defaultMessage="" />,
    },
    {
        url: "https://ik.imagekit.io/dnddecpho/airvitamin/Screenshot_20241007_173233~2_WsWKP2xDFo.jpg?updatedAt=1732898453957",
        title: <FormattedMessage id="bg_img_16" defaultMessage="" />,
    },
];

const setE = [
    {
        url: "https://ik.imagekit.io/dnddecpho/airvitamin/Screenshot_20241007_183615~2_udhKWa-NL.jpg?updatedAt=1732898453859",
        title: <FormattedMessage id="bg_img_17" defaultMessage="" />,
    },
];


const Background = () => {
    const sections = [
        { images: setA, title: "bg_title_1", desc: "bg_desc_1", number: "01" },
        { images: setB, title: "bg_title_2", desc: "bg_desc_2", number: "02" },
        { images: setC, title: "bg_title_3", desc: "bg_desc_3", number: "03" },
        { images: setD, title: "bg_title_4", desc: "bg_desc_4", number: "04" },
        { images: setE, title: "bg_title_5", desc: "bg_desc_5", number: "05" },
    ];

    return (
        <PageContainer>
            {sections.map((section, idx) => (
                <React.Fragment key={idx}>
                    <Section reversed={idx % 2 === 1}>
                        <ContentWrapper>
                            <SectionNumber>{section.number}</SectionNumber>
                            <Title>
                                <FormattedMessage id={section.title} defaultMessage="" />
                            </Title>
                            <Desc>
                                <FormattedMessage id={section.desc} defaultMessage="" />
                            </Desc>
                        </ContentWrapper>
                        <ImageGallery>
                            {section.images.map((img, index) => (
                                <ImageCard key={index} img={img.url}>
                                    <ImageLabel>{img.title}</ImageLabel>
                                </ImageCard>
                            ))}
                        </ImageGallery>
                    </Section>
                    {idx < sections.length - 1 && <Divider />}
                </React.Fragment>
            ))}
        </PageContainer>
    );
};

export default Background;
